import { AccountAbstraction } from 'services/biconomy/accountAbstraction'
import { LocalStorage } from 'services/storage/localStorage'

const accountAbstraction = new AccountAbstraction(new LocalStorage())

export default accountAbstraction
